import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Capture beforeinstallprompt before React mounts — the event can fire very
// early and would otherwise be lost before AuthContext adds its listener.
window.__pwaInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA caching and push notification support.
// The SW update flow emits a custom event that PWAUpdateBanner listens to.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        registration.addEventListener('updatefound', () => {
          const newSW = registration.installing;
          if (!newSW) return;
          newSW.addEventListener('statechange', () => {
            if (
              newSW.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              // A new SW is waiting — tell the app to show the update banner
              window.dispatchEvent(
                new CustomEvent('sw-update-available', { detail: { registration } })
              );
            }
          });
        });
      })
      .catch((err) => console.warn('SW registration failed:', err));
  });
}
